import api from "../service/api";
import { WarehouseTaskItem } from "../types/warehouse";
import { createApiStore } from "./genericStore";

const useTaskItemBaseStore = createApiStore<WarehouseTaskItem>("warehouse-task-item");

export const useWarehouseTaskItemStore = () => {
  const store = useTaskItemBaseStore();

  return {
    ...store,

    /**
     * Personel Listesi (Filtreleme için)
     */
    getStaffList: async () => {
      try {
        const requestBody = {
          filter: { field: "role.name", operator: "eq", value: "warehouse_staff" }
        };
        const res = await api.post("/user/DynamicQuery", requestBody, {
          params: { pageIndex: 1, pageSize: 1000 },
          headers: { "x-silent": "true" }
        });

        return res.data.items?.map((u: any) => ({
          label: u.name,
          value: u.id,
        })) || [];
      } catch {
        return [];
      }
    },

    /**
     * Depo Listesi (Filtreleme için)
     */
    getWarehouseList: async () => {
      try {
        const res = await api.post("/warehouse/DynamicQuery", {}, {
          params: { pageIndex: 1, pageSize: 100 },
          headers: { "x-silent": "true" }
        });
        return res.data.items?.map((w: any) => ({
          label: w.name,
          value: w.id,
        })) || [];
      } catch {
        return [];
      }
    },

    /**
     * Özet İstatistikler (KPI)
     */
    getSummaryStats: async () => {
      try {
        const res = await api.get("/warehouse-task-item/stats/summary", {
          headers: { "x-silent": "true" }
        });
        return res.data;
      } catch {
        return null;
      }
    }
  };
};
